<template>
  <div class="goToTemperHumidity">
    <ChartBox
      :title="shop_name.includes('鑫晟') ? ' 温湿度燃气监控' : '温湿度监控'"
      :tip="true"
    >
      <div class="temperContainer">
        <i
          class="el-icon-info"
          style="
            cursor: pointer;
            font-size: 23px;
            position:absolute;
            left: 110px;
            top: -40px;
          "
          title="帮助信息"
          @click="handleHelp()"
        ></i>
        <div
          class="tempItem"
          v-for="(item, index) in locationTempList"
          :key="index"
          v-if="locationTempList.length < 3"
        >
          <div class="location">{{ item.name }}</div>
          <!-- 温度 -->
          <div class="temper">
            <!-- 正常 -->
            <img
              v-if="item.temp_status == '正常'"
              src="../assets/image/normal1.png"
            />
            <!-- 警告 -->
            <img
              v-if="item.temp_status == '异常'"
              src="../assets/image/abnormal1.png"
            />
            <!-- 报警 -->
            <img
              v-if="item.temp_status == '警告'"
              src="../assets/image/warn1.png"
            />

            <img
              v-if="item.name == '大灶' && item.status == '正常'"
              src="../assets/image/ch4.png"
              style="margin-right: 15px; margin-top: 50px"
            />
            <!-- 警告 -->
            <img
              v-if="item.name == '大灶' && item.status == '异常'"
              src="../assets/image/ch4-2.png"
              style="margin-right: 15px; margin-top: 50px"
            />
            <!-- 报警 -->
            <img
              v-if="item.name == '大灶' && item.status == '警告'"
              src="../assets/image/ch4-3.png"
              style="margin-right: 15px; margin-top: 50px"
            />
            <img
              v-if="item.name == '后厨' && item.status == '正常'"
              src="../assets/image/normalPPM.png"
              style="margin-right: 15px; margin-top: 50px"
            />
            <!-- 警告 -->
            <img
              v-if="item.name == '后厨' && item.status == '异常'"
              src="../assets/image/PPM2.png"
              style="margin-right: 15px; margin-top: 50px"
            />
            <!-- 报警 -->
            <img
              v-if="item.name == '后厨' && item.status == '警告'"
              src="../assets/image/PPM.png"
              style="margin-right: 15px; margin-top: 50px"
            />
            <div class="temperNum" v-if="item.temp">{{ item.temp }}℃</div>
            <div
              class="temperNum"
              style="margin-top: 50px"
              v-if="item.name == '大灶'"
            >
              {{ item.val }} %LEL
            </div>
            <div
              class="temperNum"
              style="margin-top: 50px"
              v-if="item.name == '后厨'"
            >
              {{ item.val }} PPM
            </div>
          </div>
          <!-- 湿度 -->
          <div class="water">
            <!-- 正常 -->
            <img
              v-if="item.wet_status == '正常'"
              src="../assets/image/fullwater.png"
            />
            <!-- 警告 wet_status -->
            <img
              v-if="item.wet_status == '异常'"
              src="../assets/image/warter2.png"
            />
            <!-- 报警 -->
            <img
              v-if="item.wet_status == '警告'"
              src="../assets/image/warter3.png"
            />
            <div class="waterNum" v-if="item.wet">{{ item.wet }}%</div>
          </div>
        </div>

        <div
          style="width: 90%; margin: 0 auto"
          v-if="locationTempList.length < 3 && temp_show_tips"
        >
          <horizontal-scroll
            :text="temp_show_tips"
            :speed="8"
            :color="temp_show_color"
          />
        </div>
        <el-carousel
          style="width: 100%"
          height="230px"
          indicator-position="none"
          v-if="locationTempList.length > 2"
        >
          <el-carousel-item
            v-for="(item, index) in locationTempList2"
            :key="index"
            style="display: flex"
          >
            <div class="tempItem" v-for="(i, index) in item" :key="index">
              <div class="location">{{ i.name }}</div>
              <!-- 温度 -->
              <div class="temper">
                <!-- 正常 -->
                <img
                  v-if="i.temp_status == '正常'"
                  src="../assets/image/normal1.png"
                />
                <!-- 警告 -->
                <img
                  v-if="i.temp_status == '异常'"
                  src="../assets/image/abnormal1.png"
                />
                <!-- 报警 -->
                <img
                  v-if="i.temp_status == '警告'"
                  src="../assets/image/warn1.png"
                />
                <img
                  v-if="i.name.includes('大灶') && i.status == '正常'"
                  src="../assets/image/ch4.png"
                  style="margin-right: 15px; margin-top: 50px"
                />
                <!-- 警告 -->
                <img
                  v-if="i.name.includes('大灶') && i.status == '异常'"
                  src="../assets/image/ch4-2.png"
                  style="margin-right: 15px; margin-top: 50px"
                />
                <!-- 报警 -->
                <img
                  v-if="i.name.includes('大灶') && i.status == '警告'"
                  src="../assets/image/ch4-3.png"
                  style="margin-right: 15px; margin-top: 50px"
                />
                <img
                  v-if="i.name.includes('后厨') && i.status == '正常'"
                  src="../assets/image/normalPPM.png"
                  style="margin-right: 15px; margin-top: 50px"
                />
                <!-- 警告 -->
                <img
                  v-if="i.name.includes('后厨') && i.status == '异常'"
                  src="../assets/image/PPM2.png"
                  style="margin-right: 15px; margin-top: 50px"
                />
                <!-- 报警 -->
                <img
                  v-if="i.name.includes('后厨') && i.status == '警告'"
                  src="../assets/image/PPM.png"
                  style="margin-right: 15px; margin-top: 50px"
                />
                <div class="temperNum" v-if="i.temp">{{ i.temp }}℃</div>
                <div
                  class="temperNum"
                  style="margin-top: 50px"
                  v-if="i.name.includes('大灶')"
                >
                  {{ i.val }} %LEL
                </div>
                <div
                  class="temperNum"
                  style="margin-top: 50px"
                  v-if="i.name.includes('后厨')"
                >
                  {{ i.val }} PPM
                </div>
              </div>
              <!-- 湿度 -->
              <div class="water">
                <!-- 正常 -->
                <img
                  v-if="i.wet_status == '正常'"
                  src="../assets/image/fullwater.png"
                />
                <!-- 警告 wet_status -->
                <img
                  v-if="i.wet_status == '异常'"
                  src="../assets/image/warter2.png"
                />
                <!-- 报警 -->
                <img
                  v-if="i.wet_status == '警告'"
                  src="../assets/image/warter3.png"
                />
                <div class="waterNum" v-if="i.wet">{{ i.wet }}%</div>
              </div>
            </div>
          </el-carousel-item>
          <div
            style="
              width: 90%;
              margin: 0 auto;
              position: absolute;
              bottom: 0;
              right: 20px;
            "
            v-if="locationTempList.length > 2 && temp_show_tips"
          >
            <horizontal-scroll
              :text="temp_show_tips"
              :color="temp_show_color"
            />
          </div>
        </el-carousel>
      </div>
    </ChartBox>
    <el-dialog
      title="温湿度、燃气范围说明"
      :visible.sync="dialogVisible"
      width="500px"
      center
    >
      <div class="range-table">
        <div style="display: flex;align-items: center;margin-bottom: 20px;"> 
          <h3 style="">温度范围说明 </h3>
          <img src="../assets/image/temps.png" style="width: 26px;margin-left: 5px;">
        </div>
       
        <table class="simple-table">
          <thead>
            <tr>
              <th>位置</th>
              <th>正常区间</th>
              <th>警告区间</th>
              <th>报警区间</th>
            </tr>
          </thead>
           <tbody>
            <tr>
              <td>干调库/粮油库</td>
              <!-- <td>25℃以下</td>
              <td>25℃ - 30℃</td>
              <td>> 30℃</td> -->
               <td>30℃以下</td>
              <td>30℃ - 32℃</td>
              <td>> 32℃</td>
            </tr>
            <tr>
              <td>冷藏库</td>
              <td>0℃ - 8℃</td>
              <td>8℃ - 10℃</td>
              <td>> 10℃</td>
            </tr>
            <tr>
               <td>冷冻库</td>
              <td> ≤-18℃</td>
              <td>-18℃  ~ -15℃</td>
              <td>>-15℃</td>
            </tr>
          </tbody>
        </table>
        <div style="display: flex;align-items: center;margin-bottom: 20px;margin-top: 20px;"> 
          <h3 style="">湿度范围说明 </h3>
          <img src="../assets/image/wet.png" style="width: 25px;margin-left: 5px;">
        </div>
        <table class="simple-table">
          <thead>
            <tr>
              <th>位置</th>
              <th>正常区间</th>
              <th>警告区间</th>
              <th>报警区间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>干调库/粮油库</td>
              <td>65%以下</td>
              <td>65% - 80%</td>
              <td>> 80%</td>
            </tr>
          </tbody>
        </table>
        <div style="display: flex;align-items: center;margin-bottom: 20px;margin-top: 20px;"> 
          <h3 style="">燃气监测范围说明 </h3>
          <img src="../assets/image/jiawan2.png" style="width: 25px;margin-left: 5px;">
        </div>
        <table class="simple-table">
          <thead>
            <tr>
              <th>类型</th>
             <th>正常区间</th>
              <th>警告区间</th>
              <th>报警区间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>甲烷 <i class="el-icon-fire"></i></td>
              <td>0 %LEL</td>
              <td>2%LEL - 5%LEL</td>
              <td>> 5%LEL</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HorizontalScroll from "../components/HorizontalScroll";
import ChartBox from "../components/chartBox.vue";
import { getIotInfoV2 } from "../api/api";
import { baseImgUrl } from "../utils/request";
// 引入混入
import { myMixin } from "../common/common.js";

export default {
  data() {
    return {
      locationTempList: [],
      locationTempList2: [],
      cleanUpMemory: null,
      temp_show_tips: "",
      temp_show_color: "",
      dialogVisible: false,
      dialogVisible2: false,
    };
  },
  components: {
    ChartBox,
    HorizontalScroll,
  },
  mixins: [myMixin],
  mounted() {
    this.getIotInfoV();
    this.cleanUpMemory = setInterval(() => {
      this.getIotInfoV();
    }, 15 * 60 * 1000);
  },
  methods: {
    handleHelp() {
      console.log('11');
      
      this.dialogVisible = true;
    },
    handleHelp2() {
      this.dialogVisible2 = true;
    },
    // 获取地点
    async getIotInfoV() {
      const res = await getIotInfoV2();

      if (res.data.data.temp_show_tips) {
        this.temp_show_tips = res.data.data.temp_show_tips;
      }
      if (res.data.data.temp_show_color) {
        this.temp_show_color = res.data.data.temp_show_color;
      }

      var newArr = [];
      if (res.data.data.temp && res.data.data.temp.length > 0) {
        newArr = [...res.data.data.temp];
      }
      if (res.data.data.jiawan && res.data.data?.jiawan.length > 0) {
        newArr = [...newArr, ...res.data.data?.jiawan];
      }
      if (res.data.data.smog && res.data.data?.smog.length > 0) {
        newArr = [...newArr, ...res.data.data.smog];
      }
      this.locationTempList = newArr;

      // this.locationTempList是个数组，如果长度大于2，就把里面的item，每两个放进一个数组，就成了一个二维数组
      if (this.locationTempList.length > 2) {
        this.locationTempList2 = this.locationTempList.reduce(
          (prev, cur, index) => {
            const curIndex = Math.floor(index / 2);
            if (!prev[curIndex]) {
              prev[curIndex] = [];
            }
            prev[curIndex].push(cur);
            return prev;
          },
          []
        );
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.cleanUpMemory);
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
  background-color: #e4f1fe;
  font-weight: bold;
}
.simple-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.simple-table th,
.simple-table td {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  text-align: center;
}
.simple-table th {
  background-color: #f5f7fa;
  color: #303133;
}
// 温湿度监控
.temperContainer {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  color: white;
  position: relative;

  .tempItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;

    .location {
      height: 40px;
      line-height: 40px;
    }

    .temper {
      display: flex;
      align-items: center;
      height: 70px;

      img {
        margin-right: 4px;
        width: 40px;
        height: 45px;
        margin-left: 5px;
      }
    }

    .water {
      display: flex;
      align-items: center;
      height: 80px;
      img {
        margin-right: 3px;
      }
    }
  }
}
</style>
